export default __webpack_public_path__ + "static/media/employeegen.500f4527.png";